<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="promocodes"
        class="va-table va-table--hoverable va-table--clickable"
        api-mode
      >
        <template slot="id" slot-scope="props">
          <span>{{ props.rowData.id }}</span>
        </template>
        <template slot="name" slot-scope="props">
          <span>{{ props.rowData.code }}</span>
        </template>
        <template slot="expires_at" slot-scope="props">
          <span>{{ props.rowData.expires_at }} </span>
        </template>
        <template slot="discount" slot-scope="props">
          <span>{{ props.rowData.discount }}</span>
        </template>
        <template slot="actions" slot-scope="props">
          <va-button
            @click="update(props.rowData)"
            flat
            small
            color="gray"
            icon="fa fa-pencil"
          />
          <va-button
            @click="remove(props.rowData.id)"
            flat
            small
            color="gray"
            icon="fa fa-trash"
          />
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import api from "@/api/axios";
export default {
  props: {
    promocodes: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      showUpdateForm: false,
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:id",
          title: "Номер",
        },
        {
          name: "__slot:name",
          title: "Промокод",
        },
        {
          name: "__slot:expires_at",
          title: "Дата действия",
        },
        {
          name: "__slot:discount",
          title: "Размер промокода",
        },
        {
          name: "__slot:actions",
          title: "",
        },
      ];
    },
  },
  methods: {
    async remove(promocodeId) {
      if (confirm("Вы действительно хотите удалить ?")) {
        try {
          await api.delete(`/admin/promocodes/${promocodeId}`);
          this.$emit("needFetchPromocodes");
        } catch (error) {
          return error;
        }
      } else {
      }
    },
    update(val) {
      this.$emit("openUpdateForm", val);
    },
    modalStatus() {
      this.showUpdateForm = !this.showUpdateForm;
    },
  },
};
</script>
